// OfflineBanner — sticky strip surfaced when the browser thinks it's
// offline. The SDK still optimistically fires requests (most browsers
// queue them or return a quick TypeError); this banner is the user-
// facing signal that "your last action might not have persisted yet."
//
// Hidden in normal operation so layout doesn't shift on page load.
// When visible, it pushes content down rather than overlapping.

import { Alert } from "@sms/design-system";
import type { Locale } from "@sms/i18n";

import { makeT } from "./i18n";
import { useOnline } from "./useOnline";

export function OfflineBanner({ locale }: { locale: Locale }) {
  const online = useOnline();
  if (online) return null;
  const t = makeT(locale);
  return (
    <div
      data-testid="offline-banner"
      style={{ borderRadius: 0, marginBottom: 0 }}
    >
      <Alert intent="warning">{t("common.offline")}</Alert>
    </div>
  );
}
